import { Request } from 'commons/utils/request'
import { AdverseMediaDetailsRequest, AdverseMediaDetailsType } from '~bank-adverse-media/types/details'

export const getAdverseMediaDetails = (id: number, opts: Omit<AdverseMediaDetailsRequest, 'id'>) =>
  Request.post<AdverseMediaDetailsType, AdverseMediaDetailsRequest>(Request.urls.bank.adverseMediaDetailsWebpage, {
    id,
    ...opts
  })
